// extracted by mini-css-extract-plugin
module.exports = {"baseSearchBarBox":"BaseSearchBar_baseSearchBarBox_1kKxN","baseSearchBar":"BaseSearchBar_baseSearchBar_1W2RN"};